import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import CategoryShowcase from './components/CategoryShowcase';
import BrandStory from './components/BrandStory';
import LatestArticles from './components/LatestArticles';
import Newsletter from './components/Newsletter';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <FeaturedProducts />
        <CategoryShowcase />
        <BrandStory />
        <LatestArticles />
        <Newsletter />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '嫩小兔官方落地页——萌趣可爱嫩小兔品牌体验',
            description:
              '嫩小兔是深受年轻人喜爱的萌系潮流品牌，汇聚嫩小兔系列周边、玩偶、联名产品与限定礼盒，软萌治愈风格让你爱不释手。',
            url: 'https://www.nenxiaotu.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '嫩小兔',
              url: 'https://www.nenxiaotu.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.nenxiaotu.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}